import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Form,
  Button,
  Modal,
} from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faChevronUp,
  faStar,
  faEdit,
  faTrash,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { BaseUrl } from "../Routes/BaseUrl";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "./ProductList.css";

export const ProductListComponent = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState("Skin care");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [productToDelete, setProductToDelete] = useState(null);
  const [expandedSections, setExpandedSections] = useState({
    category: true,
    subCategory: false,
    brands: false,
  });

  // Filter options
  const categories = [
    { name: "Skin care", checked: true },
    { name: "Hair Care", checked: false },
    { name: "Baby and Mom care", checked: false },
    { name: "Sexual Wellness", checked: false },
    { name: "Oral Care", checked: false },
  ];

  const subCategories = [
    "Skin cream",
    "Sunscreen",
    "Face Wash",
    "Skin and Body Soap",
    "Acne Care",
  ];

  const brands = ["ACMED", "ACMIST", "ACNE", "ACNE IC", "ACNELAK"];

  useEffect(() => {
    fetchProducts();
  }, [selectedCategory]); // Re-fetch when category changes

  // Fetch products from products API
  const fetchProducts = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.log("No token found, using sample data");
        setSampleProducts();
        return;
      }
      
      // Fetch products from the new products API
      const response = await axios.get(
        `${BaseUrl.trim()}/admin/products?category=${selectedCategory}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      
      if (response.data && response.data.data && response.data.data.items) {
        const products = response.data.data.items.map(item => ({
          _id: item._id,
          titleName: item.name,
          prize: item.price,
          productImages: item.image ? [item.image] : [],
          brand: item.brand,
          category: item.category,
          stock: item.stock,
          description: item.description,
        }));
        
        if (products.length > 0) {
          setProducts(products);
        } else {
          // If no products found, use sample data
          setSampleProducts();
        }
      } else {
        setSampleProducts();
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching products:", error);
      if (error.response) {
        console.error("Error response:", error.response.data);
      }
      // Use sample data on error
      setSampleProducts();
    }
  };

  const setSampleProducts = () => {
    // Sample product data organized by category
    const allSampleProducts = {
      "Skin care": [
        {
          _id: "skin-1",
          titleName: "Dry Apricot Face Cream",
          prize: "121",
          productImages: ["https://images.unsplash.com/photo-1556228578-0d85b1a4d571?w=400&h=300&fit=crop"],
          brand: "ACNE",
          category: "Skin care",
        },
        {
          _id: "skin-2",
          titleName: "Moisturizing Lotion",
          prize: "150",
          productImages: ["https://images.unsplash.com/photo-1620916566398-39f1143ab7be?w=400&h=300&fit=crop"],
          brand: "ACMIST",
          category: "Skin care",
        },
        {
          _id: "skin-3",
          titleName: "Sunscreen SPF 50",
          prize: "199",
          productImages: ["https://images.unsplash.com/photo-1608248543803-ba4f8c70ae0b?w=400&h=300&fit=crop"],
          brand: "ACMED",
          category: "Skin care",
        },
        {
          _id: "skin-4",
          titleName: "Face Wash Gel",
          prize: "89",
          productImages: ["https://images.unsplash.com/photo-1556228720-195a672e8a03?w=400&h=300&fit=crop"],
          brand: "ACNE IC",
          category: "Skin care",
        },
        {
          _id: "skin-5",
          titleName: "Anti-Aging Serum",
          prize: "299",
          productImages: ["https://images.unsplash.com/photo-1620916297397-fd5272e3a1d0?w=400&h=300&fit=crop"],
          brand: "ACNELAK",
          category: "Skin care",
        },
        {
          _id: "skin-6",
          titleName: "Night Cream",
          prize: "175",
          productImages: ["https://images.unsplash.com/photo-1571875257727-256c39da42af?w=400&h=300&fit=crop"],
          brand: "ACMED",
          category: "Skin care",
        },
        {
          _id: "skin-7",
          titleName: "Vitamin C Serum",
          prize: "250",
          productImages: ["https://images.unsplash.com/photo-1608248543803-ba4f8c70ae0b?w=400&h=300&fit=crop"],
          brand: "ACMED",
          category: "Skin care",
        },
        {
          _id: "skin-8",
          titleName: "Eye Cream",
          prize: "180",
          productImages: ["https://images.unsplash.com/photo-1556228720-195a672e8a03?w=400&h=300&fit=crop"],
          brand: "ACNELAK",
          category: "Skin care",
        },
        {
          _id: "skin-9",
          titleName: "Hydrating Mask",
          prize: "95",
          productImages: ["https://images.unsplash.com/photo-1556228578-0d85b1a4d571?w=400&h=300&fit=crop"],
          brand: "ACMIST",
          category: "Skin care",
        },
      ],
      "Hair Care": [
        {
          _id: "hair-1",
          titleName: "Argan Oil Shampoo",
          prize: "145",
          productImages: ["https://images.unsplash.com/photo-1535585209827-a15fcdbc4c2d?w=400&h=300&fit=crop"],
          brand: "ACMED",
          category: "Hair Care",
        },
        {
          _id: "hair-2",
          titleName: "Deep Conditioning Mask",
          prize: "199",
          productImages: ["https://images.unsplash.com/photo-1522338242992-e1a54906a8da?w=400&h=300&fit=crop"],
          brand: "ACMIST",
          category: "Hair Care",
        },
        {
          _id: "hair-3",
          titleName: "Anti-Dandruff Shampoo",
          prize: "129",
          productImages: ["https://images.unsplash.com/photo-1527799820374-dcf8d9d4a388?w=400&h=300&fit=crop"],
          brand: "ACNE",
          category: "Hair Care",
        },
        {
          _id: "hair-4",
          titleName: "Hair Growth Serum",
          prize: "299",
          productImages: ["https://images.unsplash.com/photo-1608248543803-ba4f8c70ae0b?w=400&h=300&fit=crop"],
          brand: "ACNELAK",
          category: "Hair Care",
        },
        {
          _id: "hair-5",
          titleName: "Keratin Treatment",
          prize: "350",
          productImages: ["https://images.unsplash.com/photo-1519415510236-718bdfcd89c8?w=400&h=300&fit=crop"],
          brand: "ACMED",
          category: "Hair Care",
        },
        {
          _id: "hair-6",
          titleName: "Leave-in Conditioner",
          prize: "165",
          productImages: ["https://images.unsplash.com/photo-1571875257727-256c39da42af?w=400&h=300&fit=crop"],
          brand: "ACMIST",
          category: "Hair Care",
        },
      ],
      "Baby and Mom care": [
        {
          _id: "baby-1",
          titleName: "Baby Lotion",
          prize: "120",
          productImages: ["https://images.unsplash.com/photo-1515488042361-ee00e0ddd4e4?w=400&h=300&fit=crop"],
          brand: "ACMED",
          category: "Baby and Mom care",
        },
        {
          _id: "baby-2",
          titleName: "Diaper Rash Cream",
          prize: "95",
          productImages: ["https://images.unsplash.com/photo-1556228578-0d85b1a4d571?w=400&h=300&fit=crop"],
          brand: "ACNE",
          category: "Baby and Mom care",
        },
        {
          _id: "baby-3",
          titleName: "Baby Shampoo",
          prize: "110",
          productImages: ["https://images.unsplash.com/photo-1535585209827-a15fcdbc4c2d?w=400&h=300&fit=crop"],
          brand: "ACMIST",
          category: "Baby and Mom care",
        },
        {
          _id: "baby-4",
          titleName: "Baby Oil",
          prize: "85",
          productImages: ["https://images.unsplash.com/photo-1620916566398-39f1143ab7be?w=400&h=300&fit=crop"],
          brand: "ACMED",
          category: "Baby and Mom care",
        },
        {
          _id: "baby-5",
          titleName: "Baby Powder",
          prize: "75",
          productImages: ["https://images.unsplash.com/photo-1556228720-195a672e8a03?w=400&h=300&fit=crop"],
          brand: "ACNE IC",
          category: "Baby and Mom care",
        },
        {
          _id: "baby-6",
          titleName: "Nursing Cream",
          prize: "145",
          productImages: ["https://images.unsplash.com/photo-1571875257727-256c39da42af?w=400&h=300&fit=crop"],
          brand: "ACNELAK",
          category: "Baby and Mom care",
        },
      ],
      "Sexual Wellness": [
        {
          _id: "wellness-1",
          titleName: "Intimate Wash",
          prize: "135",
          productImages: ["https://images.unsplash.com/photo-1556228720-195a672e8a03?w=400&h=300&fit=crop"],
          brand: "ACMED",
          category: "Sexual Wellness",
        },
        {
          _id: "wellness-2",
          titleName: "Lubricant Gel",
          prize: "199",
          productImages: ["https://images.unsplash.com/photo-1620916566398-39f1143ab7be?w=400&h=300&fit=crop"],
          brand: "ACMIST",
          category: "Sexual Wellness",
        },
        {
          _id: "wellness-3",
          titleName: "Massage Oil",
          prize: "175",
          productImages: ["https://images.unsplash.com/photo-1608248543803-ba4f8c70ae0b?w=400&h=300&fit=crop"],
          brand: "ACNE",
          category: "Sexual Wellness",
        },
        {
          _id: "wellness-4",
          titleName: "Intimate Moisturizer",
          prize: "165",
          productImages: ["https://images.unsplash.com/photo-1556228578-0d85b1a4d571?w=400&h=300&fit=crop"],
          brand: "ACNELAK",
          category: "Sexual Wellness",
        },
      ],
      "Oral Care": [
        {
          _id: "oral-1",
          titleName: "Whitening Toothpaste",
          prize: "89",
          productImages: ["https://images.unsplash.com/photo-1607613009820-a29f7bb81c04?w=400&h=300&fit=crop"],
          brand: "ACMED",
          category: "Oral Care",
        },
        {
          _id: "oral-2",
          titleName: "Mouthwash",
          prize: "125",
          productImages: ["https://images.unsplash.com/photo-1620916566398-39f1143ab7be?w=400&h=300&fit=crop"],
          brand: "ACMIST",
          category: "Oral Care",
        },
        {
          _id: "oral-3",
          titleName: "Dental Floss",
          prize: "45",
          productImages: ["https://images.unsplash.com/photo-1556228720-195a672e8a03?w=400&h=300&fit=crop"],
          brand: "ACNE",
          category: "Oral Care",
        },
        {
          _id: "oral-4",
          titleName: "Sensitive Toothpaste",
          prize: "95",
          productImages: ["https://images.unsplash.com/photo-1607613009820-a29f7bb81c04?w=400&h=300&fit=crop"],
          brand: "ACNE IC",
          category: "Oral Care",
        },
        {
          _id: "oral-5",
          titleName: "Tongue Cleaner",
          prize: "35",
          productImages: ["https://images.unsplash.com/photo-1556228578-0d85b1a4d571?w=400&h=300&fit=crop"],
          brand: "ACNELAK",
          category: "Oral Care",
        },
        {
          _id: "oral-6",
          titleName: "Teeth Whitening Strips",
          prize: "299",
          productImages: ["https://images.unsplash.com/photo-1607613009820-a29f7bb81c04?w=400&h=300&fit=crop"],
          brand: "ACMED",
          category: "Oral Care",
        },
      ],
    };

    // Set products based on selected category
    const categoryProducts = allSampleProducts[selectedCategory] || allSampleProducts["Skin care"];
    setProducts(categoryProducts);
    setLoading(false);
  };

  const toggleSection = (section) => {
    setExpandedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const handleAddToCart = (product) => {
    try {
      const productName = product.titleName || product.name || "Product";
      toast.success(`${productName} added to cart`);
    } catch (error) {
      console.error("Error adding to cart:", error);
      toast.error("Failed to add to cart");
    }
  };

  const handleEdit = (productId) => {
    navigate(`/ProductEdit/${productId}`);
  };

  const handleDeleteClick = (product) => {
    setProductToDelete(product);
    setShowDeleteModal(true);
  };

  const handleDeleteConfirm = async () => {
    try {
      const token = localStorage.getItem("token");
      await axios.delete(
        `${BaseUrl.trim()}/admin/products/${productToDelete._id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      
      toast.success("Product deleted successfully");
      setShowDeleteModal(false);
      setProductToDelete(null);
      fetchProducts(); // Refresh the list
    } catch (error) {
      console.error("Error deleting product:", error);
      toast.error("Failed to delete product");
    }
  };

  const handleAddProduct = () => {
    navigate("/AddProduct");
  };

  const renderStars = (rating = 3.0) => {
    return (
      <div className="d-inline-flex align-items-center">
        {[...Array(5)].map((_, index) => (
          <FontAwesomeIcon
            key={index}
            icon={faStar}
            className={index < Math.floor(rating) ? "text-warning" : "text-muted"}
            size="xs"
          />
        ))}
      </div>
    );
  };

  if (loading) {
    return <div className="text-center py-5">Loading products...</div>;
  }

  return (
    <div className="product-list-container">
      <Row>
        {/* Sidebar Filters */}
        <Col lg={3} className="mb-4">
          <Card className="border-0 shadow-sm">
            <Card.Body>
              <h5 className="mb-4">Filter</h5>

              {/* Category Filter */}
              <div className="filter-section mb-4">
                <div
                  className="d-flex justify-content-between align-items-center mb-3 cursor-pointer"
                  onClick={() => toggleSection("category")}
                >
                  <h6 className="mb-0">Category</h6>
                  <FontAwesomeIcon
                    icon={expandedSections.category ? faChevronUp : faChevronDown}
                  />
                </div>
                {expandedSections.category && (
                  <div>
                    {categories.map((cat, index) => (
                      <Form.Check
                        key={index}
                        type="radio"
                        name="category"
                        id={`category-${index}`}
                        label={cat.name}
                        checked={selectedCategory === cat.name}
                        className="mb-2"
                        onChange={() => setSelectedCategory(cat.name)}
                      />
                    ))}
                    <Button variant="link" size="sm" className="p-0 text-primary">
                      Read more →
                    </Button>
                  </div>
                )}
              </div>

              {/* Sub Category Filter */}
              <div className="filter-section mb-4">
                <div
                  className="d-flex justify-content-between align-items-center mb-3 cursor-pointer"
                  onClick={() => toggleSection("subCategory")}
                >
                  <h6 className="mb-0">Sub Category</h6>
                  <FontAwesomeIcon
                    icon={expandedSections.subCategory ? faChevronUp : faChevronDown}
                  />
                </div>
                {expandedSections.subCategory && (
                  <div>
                    {subCategories.map((subCat, index) => (
                      <Form.Check
                        key={index}
                        type="checkbox"
                        id={`subcategory-${index}`}
                        label={subCat}
                        className="mb-2"
                      />
                    ))}
                    <Button variant="link" size="sm" className="p-0 text-primary">
                      Read more →
                    </Button>
                  </div>
                )}
              </div>

              {/* Brands Filter */}
              <div className="filter-section">
                <div
                  className="d-flex justify-content-between align-items-center mb-3 cursor-pointer"
                  onClick={() => toggleSection("brands")}
                >
                  <h6 className="mb-0">Brands</h6>
                  <FontAwesomeIcon
                    icon={expandedSections.brands ? faChevronUp : faChevronDown}
                  />
                </div>
                {expandedSections.brands && (
                  <div>
                    {brands.map((brand, index) => (
                      <Form.Check
                        key={index}
                        type="checkbox"
                        id={`brand-${index}`}
                        label={brand}
                        className="mb-2"
                      />
                    ))}
                    <Button variant="link" size="sm" className="p-0 text-primary">
                      Read more →
                    </Button>
                  </div>
                )}
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* Products Grid */}
        <Col lg={9}>
          <div className="mb-4 d-flex justify-content-between align-items-center">
            <h4 className="mb-0">{selectedCategory}</h4>
            <Button variant="success" onClick={handleAddProduct}>
              <FontAwesomeIcon icon={faPlus} className="me-2" />
              Add Product
            </Button>
          </div>

          <Row>
            {products.length > 0 ? (
              products.map((product, index) => (
                <Col key={product._id || index} md={6} lg={4} className="mb-4">
                  <Card className="product-card border-0 shadow-sm h-100">
                    <div className="product-image-wrapper">
                      <Card.Img
                        variant="top"
                        src={
                          product.productImages && product.productImages.length > 0
                            ? product.productImages[0]
                            : "https://via.placeholder.com/300x200?text=No+Image"
                        }
                        className="product-image"
                        onError={(e) => {
                          e.target.src = "https://via.placeholder.com/300x200?text=No+Image";
                        }}
                      />
                      <div className="product-actions">
                        <Button
                          variant="light"
                          size="sm"
                          className="me-2"
                          onClick={() => handleEdit(product._id)}
                        >
                          <FontAwesomeIcon icon={faEdit} />
                        </Button>
                        <Button
                          variant="danger"
                          size="sm"
                          onClick={() => handleDeleteClick(product)}
                        >
                          <FontAwesomeIcon icon={faTrash} />
                        </Button>
                      </div>
                    </div>
                    <Card.Body className="d-flex flex-column">
                      <Card.Title className="product-title">
                        {product.titleName || product.name || "Product Name"}
                      </Card.Title>
                      <div className="product-price mb-2">
                        <span className="text-success fw-bold">
                          Rs {product.prize || product.price || "0"}
                        </span>
                      </div>
                      <div className="product-rating mb-3">
                        <span className="me-2">3.0</span>
                        {renderStars(3.0)}
                      </div>
                      <Button
                        variant="success"
                        className="w-100 mt-auto add-to-cart-btn"
                        onClick={() => handleAddToCart(product)}
                      >
                        Add to Cart
                      </Button>
                    </Card.Body>
                  </Card>
                </Col>
              ))
            ) : (
              <Col xs={12}>
                <div className="text-center py-5">
                  <p className="text-muted">No products found</p>
                  <Button variant="success" onClick={handleAddProduct}>
                    <FontAwesomeIcon icon={faPlus} className="me-2" />
                    Add Your First Product
                  </Button>
                </div>
              </Col>
            )}
          </Row>

          {products.length > 0 && (
            <div className="text-center mt-4">
              <Button variant="outline-success">View All</Button>
            </div>
          )}
        </Col>
      </Row>

      {/* Delete Confirmation Modal */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete "{productToDelete?.titleName || productToDelete?.name}"?
          This action cannot be undone.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDeleteConfirm}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
